import "../public/styles/_fonts.css";

import { KeycloakProvider } from "@keycloak/keycloak-ui-shared";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { environment } from "./environment";
import { i18n } from "./i18n";
import { Root } from "./root/Root";
import {PersonalInfoProvider} from "./providers/PersonalInfoProvider";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import theme from './theme';
import { AlertProvider } from "./alerts/Alerts";
import { ContentProvider } from "./providers/ContentProvider";

// Initialize required components before rendering app.
await i18n.init();

const container = document.getElementById("app");
const root = createRoot(container!);

root.render(
  <StrictMode>
    <KeycloakProvider environment={environment}>
      <ThemeProvider theme={theme}>
        <AlertProvider>
          <ContentProvider>
            <PersonalInfoProvider>
              <Root />
            </PersonalInfoProvider>
          </ContentProvider>
        </AlertProvider>
      </ThemeProvider>
    </KeycloakProvider>
  </StrictMode>,
);
